export enum RenewalType {
  NEVER = "NEVER",
  SET_DATE = "SET_DATE",
  INDIVIDUAL_START_DATE = "INDIVIDUAL_START_DATE",
}

